import React, { useState } from "react";
import ReactPlayer from "react-player";
import cx from "clsx";

import ModalCloseButton from "@/components/shared/modalCloseButton";

// import globalStyles from "@/styles/global.module.scss";
import styles from "./filmModal.module.scss";

const FilmModal = (props) => {
  const { videoUrl, isDesktop, onClose } = props;

  const [isReady, setIsReady] = useState(false);
  const [isPlaying, setIsPlaying] = useState(true); // autoPlay
  const memoSetReady = (val) => () => setIsReady(val);
  const handleCloseModal = () => {
    setIsPlaying(false);
    onClose();
  };
  const handlePlay = () => setIsPlaying(true);
  const handlePause = () => setIsPlaying(false);

  return (
    <div className={styles.container}>
      <ModalCloseButton isDesktop={isDesktop} onClick={handleCloseModal} />

      <div className={styles.videoContainer}>
        <ReactPlayer
          className={cx(styles.player, isReady && styles.ready)}
          url={videoUrl}
          width="100%"
          height="100%"
          config={{
            vimeo: {
              playerOptions: { controls: true },
              preload: true,
            },
          }}
          playing={isPlaying}
          onReady={memoSetReady(true)}
          onPlay={handlePlay}
          onPause={handlePause}
        />
      </div>
    </div>
  );
};

FilmModal.defaultProps = {
  videoUrl: "https://player.vimeo.com/video/525658187",
};

export default FilmModal;
